import DefaultProps from '../../commonTypes/defaultprops.types';
import { ButtonProps, ButtonStyles } from '../Button/button.types';
import Handler from 'commonTypes/handler.types';

export enum OverflowTypes {
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
  SCROLL = 'scroll',
  AUTO = 'auto'
}

export interface ButtonGroupProps extends DefaultProps {
  data: ButtonProps[];
  buttonGroupID?: string; // Custom ID for button group. Returned on change for identification
  defaultSelected?: number | number[];
  handlers?: Handler;
  inline?: boolean;
  multiple?: boolean;
  overflow?: OverflowTypes;
  selected?: number | number[];
  selectedStyleName?: ButtonStyles;
}
